/* Automatically focus on an input when clicking on a its pre/append */

$(document).on("click", ".input-group-prepend, .input-group-append", function () {
  $(this).parent(".input-group").find("input, select, textarea").focus();
});
